<template>
    <div>
        <div class="mt-4 pt-4 text-center">
            <div class="row">
                <div class="col-md-4 col-xs-6 verify-page">
                    <div class="card pb-3">
                        <div class="card-body text-center">
                            <div>
                                <img src="@/assets/img/logo.png" class="w-100">
                                <h3>Verify a certificate</h3>
                            </div>
                            <div class="mt-4 text-start">
                                <label>Enter Certificate No:.</label>
                                <input type="text" class="form-control" v-model="reg_no">
                                <button class="btn btn-outline-info rounded-pill mt-2" v-on:click="validate()">VALIDATE</button>
                            </div>
                        </div>
                    </div>

                    <div class="alert alert-success mt-3" v-if="isExist == 1">
                      <div class=""><h3 v-html="msg"></h3></div>
                      <div class="">
                        <hr />
                        <div class=" cerf text-start">
                            This certifies testing performed for <strong>{{ cerf.org_name }}</strong> with regard to <ul class="text-info" v-html="cerf.scope"></ul> and is valid until <strong>{{ cerf.valid_until }}</strong>. <strong>{{ cerf.very_high }}</strong> Very High, <strong>{{ cerf.high }}</strong> High and <strong>{{ cerf.medium }}</strong> Medium vulnerabilities were identified but not yet resolved as part of the scope of this test.
                        </div>
                      </div>
                    </div>
                    <div class="alert alert-danger mt-3" v-else-if="isExist == 2">
                        <p>The certificate ID provided was unable to be validated.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            reg_no: '',
            isExist: 0,
            msg: '',
            cerf: {
                org_name: '',
                scope: '',
                very_high: 0,
                high: 0,
                medium: 0,
                valid_from: '',
                valid_until: '',
            }
        }
    },

    methods: {
        validate() {
            if (this.cerf != "") {

                const me = this;
                const uninterceptedAxiosInstance = axios.create();
                uninterceptedAxiosInstance({
                        method: 'post',
                        url: this.$server + 'validatecert',
                        headers: {
                            "content-type": "application/json"
                        },
                        data: {
                            reg_no: me.reg_no
                        }
                    }).then(res => {
                        if (res.data.success) {
                            this.isExist = 1;
                            this.msg = res.data.message;
                            this.cerf.org_name = res.data.org_name;
                            this.cerf = res.data.data;

                        } else {
                            this.isExist = 2;
                        }
                    });

            } else {
                this.$swal({
                    title: 'Certificate No:. is required',
                    icon: 'error'
                  });
            }
        }
    },

}
</script>